import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AccessoryCheckDto,
  AccessoryCheckItemDto,
  AccessoryCheckItemReferenceDto,
  AccessoryCheckReferenceDto,
  AppPermission,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import AccessoryCheckInline from "./AccessoryCheckInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: AccessoryCheckDto | AccessoryCheckReferenceDto | null | undefined;
  entityId?: string | null;
  item?: AccessoryCheckItemDto | AccessoryCheckItemReferenceDto;
  itemId?: string | null;
}

export default function AccessoryCheckLink({
  entity,
  entityId,
  item,
  itemId,
  inlineProps,
  ...otherProps
}: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.AccessoryCheckRead]}
      to={ROUTE_PATH.ACCESSORY_CHECK_VIEW(entity?.id || entityId || "")}
      content={
        <AccessoryCheckInline
          entity={entity}
          entityId={entityId}
          item={item}
          itemId={itemId}
          {...inlineProps}
        />
      }
      {...otherProps}
    />
  );
}
